var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaperClamp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 698.92 237.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #727373;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -3896.1,
    y1: -52.49,
    x2: -3891.11,
    y2: -52.49,
    gradientTransform: "translate(2235.56 139985.52) rotate(90) scale(35.93 -35.93)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00071b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#01081c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#070f23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#121b2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#212c3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#354255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#4d5d6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#697c8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6d8193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#677b8d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#4b5f71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#36495c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#273a4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#1e3144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1c2f42"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M383.34,81.66v-7.97H34.77c-9.78-.02-18.63,3.41-24.91,9.48C3.54,89.23-.03,97.82,0,107.05c0,3.09.39,6.24,1.16,9.42l19.83,81.56h0c2.73,11.12,9.62,20.68,18.43,27.63,8.83,6.92,19.75,11.34,31.2,11.37h557.68c11.45-.03,22.38-4.45,31.2-11.37,8.81-6.95,15.7-16.51,18.43-27.63l19.84-81.56c.77-3.18,1.16-6.33,1.16-9.42.03-9.23-3.54-17.82-9.85-23.87-6.28-6.07-15.13-9.5-24.92-9.48h-280.81v15.94h280.81c6.19.02,10.74,2.03,13.86,5.02,3.1,3.02,4.95,7.12,4.97,12.39,0,1.76-.22,3.65-.71,5.65l-19.83,81.57h0c-1.67,6.98-6.41,13.88-12.79,18.86-6.36,5.02-14.18,7.99-21.36,7.96H70.62c-7.18.03-15-2.95-21.36-7.96-6.37-4.99-11.12-11.88-12.79-18.86h0l-19.84-81.57h0c-.48-2-.71-3.89-.71-5.65.03-5.27,1.87-9.37,4.97-12.39,3.12-2.99,7.68-5,13.86-5.02h348.57v-7.97Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 106.46,
    width: 486,
    height: 163.33
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperClamp);
export default __webpack_public_path__ + "static/media/PaperClamp.6bf2e580ce71aa1afc89bd113b1c53a5.svg";
export { ForwardRef as ReactComponent };